import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// Assets
import mainLogo from "../../assets/logos/main-logo.png";

// Config
import colors from "../../config/colors";
import { externalRoutes } from "../../config/routes";
import { userTypes } from "../../config/values";
import styles from "../../config/styles";

// Hooks
import useTranslate from "../../hooks/useTranslate";

// Actions
import { onSignOut } from "../../state/user/actions";

// Components
import GoBackLink from "../../components/GoBackLink";
import Link from "../../components/Link";
import PincodeForm from "../../components/PincodeForm";
import Text from "../../components/Text";

const useStyles = makeStyles(theme => ({
  root: {
    width: 640,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "auto"
    }
  },
  paper: {
    border: styles.values.border
  },
  logo: {
    height: 28
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(4, 0, 0),
    paddingLeft: 90,
    paddingRight: 90,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    }
  },
  title: {
    padding: theme.spacing(1.5, 0, 1),
    color: colors.riverBed,
    textTransform: "uppercase"
  },
  goBack: {
    marginTop: 40
  },
  goBackHighlight: {
    color: colors.pictonBlue
  },
  footer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: theme.spacing(3, 0),
    paddingLeft: 90,
    paddingRight: 90
  },
  footerLink: styles.mixins.link
}));

const PinLockScreen = ({ onAuthorize }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const getText = useTranslate();

  const handleSignOut = () => dispatch(onSignOut());
  const handleSubmit = () => onAuthorize();

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <div className={classes.contentContainer}>
          <img className={classes.logo} src={mainLogo} alt="Kulpa" />
          <GoBackLink
            className={classes.goBack}
            onClick={handleSignOut}
            text="common.valueLabels.backTo"
            values={{
              1: (
                <span key={1} className={classes.goBackHighlight}>
                  {getText("pageTitles.login")}
                </span>
              ),
              isComponent: true
            }}
          />
          <Text
            type="heading1"
            className={classes.title}
            text="createPasscodePage.cardTitle"
          />
        </div>
        <PincodeForm onSubmit={handleSubmit} hideHeader />
        <div className={classes.footer}>
          <Text
            type="subtitleLight"
            align="center"
            text="loginPage.disclaimerLinks"
            values={{
              1: (
                <Link
                  key={1}
                  className={classes.footerLink}
                  target="_blank"
                  to={externalRoutes.terms(userTypes.Victim)}
                >
                  {getText("settingsPage.terms")}
                </Link>
              ),
              2: (
                <Link
                  key={2}
                  className={classes.footerLink}
                  target="_blank"
                  to={externalRoutes.privacy(userTypes.Victim)}
                >
                  {getText("common.valueLabels.privacyNotice")}
                </Link>
              ),
              isComponent: true
            }}
          />
        </div>
      </Paper>
    </div>
  );
};

PinLockScreen.propTypes = {
  onAuthorize: PropTypes.func.isRequired
};

export default PinLockScreen;
